export default function download ({ file, url}) {
    let link = document.createElement("a");
    link.setAttribute('download', file);
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
}